import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreatePurchaseTenderMutationRequest, CreatePurchaseTenderMutationResponse, CreatePurchaseTender400, CreatePurchaseTender401, CreatePurchaseTender403, CreatePurchaseTender422, CreatePurchaseTender429, CreatePurchaseTender500 } from "../types/CreatePurchaseTender";

/**
 * @link /api/purchase-tenders/v1/create_tender
 */

export function useCreatePurchaseTender <TData = CreatePurchaseTenderMutationResponse, TError = CreatePurchaseTender400 | CreatePurchaseTender401 | CreatePurchaseTender403 | CreatePurchaseTender422 | CreatePurchaseTender429 | CreatePurchaseTender500, TVariables = CreatePurchaseTenderMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/v1/create_tender`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
